export const selectAppState = store => store.app;
    